import { MolhamListTargetable } from "apiTypes";
import MolhamModalOffcanvas from "components/MolhamModalOffCanvas";
import { tragetableFallbackImg } from "config";
import useMobile from "customHooks/useMobile";
import useModal from "customHooks/useModal";
import useTranslation from "next-translate/useTranslation";
import Image from "next/image";
import { memo, useState } from "react";
import CloseBtn from "../CloseBtn";
import CustomContentLoader from "../CustomContentLoader";
import MolhamButton from "../MolhamButton";

type Props = {
  data?: MolhamListTargetable;
  onDonateClick?: (id: number) => void;
};
const SponsorCard = ({ data, onDonateClick }: Props) => {
  const isMobile = useMobile("md");
  const m = useModal();
  const { t } = useTranslation("common");
  const num = isMobile ? 100 : 230;
  const [loading, setLoading] = useState(false);
  const onClick = async () => {
    setLoading(true);
    await onDonateClick(data?.id);
    setLoading(false);
    // m.handleCloseModal();
  };
  if (!data)
    return (
      <div className="centered" style={{ width: num, height: num }}>
        <CustomContentLoader
          className="rounded"
          viewBox={`0 0 ${num} ${num}`}
          style={{ width: num }}
        >
          <rect width="100%" height="100%"></rect>
        </CustomContentLoader>
      </div>
    );
  return (
    <div className="centered" style={{ height: num }}>
      {/* <Link href={'/sponsorships/'+data?.id}> */}
      <MolhamModalOffcanvas
        onHide={m.handleCloseModal}
        show={m.showModal}
        body={{ className: "p-0" }}
        fullscreen
        swipeToClose={false}
        size="lg"
      >
        <div className="d-flex flex-column position-relative justify-content-between h-100">
          <div className="d-flex flex-column ">
            <div
              className="position-absolute "
              style={{ top: 16, insetInlineEnd: 16 }}
            >
              <CloseBtn className="bg-white" closeModal={m.handleCloseModal} />
            </div>
            <Image
              unoptimized
              alt={data?.id.toString()}
              src={
                data?.preview_image?.thumbnails["16:9"] || tragetableFallbackImg
              }
              width={1920}
              height={1080}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                maxHeight: isMobile ? 240 : "unset",
              }}
            />
            <div className="d-flex flex-column p-3">
              <h3 className="m-0 p-0 mb-3 lh17">{data?.contents.title}</h3>
              <h6 className="lh17">{data?.contents.raw_details}</h6>
            </div>
          </div>
          <div className="m-3 d-flex">
            <MolhamButton
              onClick={onClick}
              id="sponsor-me-button"
              isLoading={loading}
              label={t("sponsor-me")}
              className="w-100"
              labelClassName="fw-bold fs-lg"
              endIcon="fe-heart fw-bold"
            />
          </div>
        </div>
      </MolhamModalOffcanvas>
      <Image
        unoptimized
        onClick={m.handleShowModal}
        alt={data?.id.toString()}
        src={data?.preview_image?.thumbnails?.["1:1"] || tragetableFallbackImg}
        style={{
          height: num,
          width: num,
          filter: data.funded === 0 ? "grayscale(100%)" : "",
        }}
        width={num}
        height={num}
        className="sponsor-me-card rounded"
      />
      {/* </Link> */}
    </div>
  );
};
export default memo(SponsorCard);
